// The first callback runs before the next paint; the second resumes after that paint has had a chance to render.
export const waitForNextPaint = (): Promise<void> =>
  new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
